<div class="app-container app-theme-white body-tabs-shadow">
    <div class="app-container">
        <div class="h-100">
            <div class="h-100 no-gutters row">
                <div class="d-none d-lg-block col-lg-5">
                    <div class="slider-light">
                        <div class="slick-slider h-100">
                            <div>
                                <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate"
                                    tabindex="-1">
                                    <div class="slide-img-bg"
                                        style="background-image: url('assets/images/Cust-login.png');"></div>
                                    <div class="slider-content">
                                        <h3>Change Your Passsword</h3>
                                        <!-- <p>Designed exclusively for you—offering real-time project updates, dedicated service and support, and AI-driven assistance at your fingertips.
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-7">
                    <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
                        <div class="app-logo">
                        </div>
                        <h4 class="mb-0">
                            <span class="d-block">Change Password</span>
                        </h4>
                        <div class="divider row"></div>
                        <div>
                            <form [formGroup]="changePasswordForm">
                                <div class="form-row">
                                    <!-- <input type="hidden" name="userType" formControlName="userType" /> -->
                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="changePassword" class="">Change Password</label>
                                            <input name="changePassword" id="changePassword"
                                                formControlName="changePassword" placeholder="Change Password"
                                                type="email" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && changePasswordForm.controls['changePassword'].errors }">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="confirmPassword" class="">Confirm Password</label>
                                            <input name="confirmPassword" id="confirmPassword"
                                                formControlName="confirmPassword" placeholder="Confirm Password"
                                                type="text" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && changePasswordForm.controls['confirmPassword'].errors }">
                                        </div>
                                    </div>
                                </div>
                                <div class="divider row"></div>
                                <div class="d-flex align-items-center">
                                    <div class="ml-auto">
                                        <button class="btn btn-danger btn-lg" (click)="onCancel()"
                                            [hidden]="!sendotpDiv" style="margin-left: 10px;">Cancel</button>
                                        <button class="btn btn-primary btn-lg" (click)="onSubmit()"
                                            [hidden]="!sendotpDiv" style="margin-left: 10px;">Submit</button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>